import { render } from "./Coming_soon.vue?vue&type=template&id=3ba2daa6&scoped=true"
import script from "./Coming_soon.vue?vue&type=script&lang=js"
export * from "./Coming_soon.vue?vue&type=script&lang=js"

import "./Coming_soon.vue?vue&type=style&index=0&id=3ba2daa6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ba2daa6"]])

export default __exports__